import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, TextField, Grid } from "@mui/material";
import useStyles from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

//Api routes
import settingsApi from "Services/Settings";

const Settings = () => {
  //
  const classes = useStyles();
  const dispatch = useDispatch();

  //
  const [userDetails, setUserDetails] = useState([]);

  // Get Business Settings
  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setUserDetails(res?.data?.data);
      } else {
        setUserDetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getUserDetails().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  //

  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      oldPassword: formValues?.oldPassword,
      newPassword: formValues?.newPassword,
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated password successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update the password",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi
      .changeUserPassword(userDetails._id, { ...data })
      .then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validationSchema: yup.object({
      newPassword: yup
        .string()
        .min(6, "Must be greater than 6 characters or long")
        .max(16, "Must be less than 16 character or equal to 16"),
      confirmPassword: yup
        .string()
        .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: handleSettings,
  });

  return (
    <>
      <br></br>
      <br></br>
      <Grid container className={classes.cardContainer}>
        <Grid
          container
          xs={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.businessSettingsContainer}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.container}
          >
            <div style={{ padding: "15px" }}>
              <Typography variant="h5">Change Password</Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12} xl={12}>
            {/* Enable Mail */}
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.fieldWrapper}
            >
              <TextField
                name="oldPassword"
                id="oldPassword"
                label="Old Password"
                value={formik?.values?.oldPassword}
                defaultValue={formik?.values?.oldPassword}
                onChange={formik?.handleChange}
                error={
                  formik?.errors?.oldPassword && formik?.touched?.oldPassword
                }
                helperText={
                  formik?.errors?.oldPassword &&
                  formik?.touched?.oldPassword &&
                  formik?.errors?.oldPassword
                }
                fullWidth
                variant="outlined"
                size="small"
              ></TextField>
            </Grid>

            {/* New Password */}
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.fieldWrapper}
            >
              <TextField
                name="newPassword"
                id="newPassword"
                label="New Password"
                value={formik?.values?.newPassword}
                defaultValue={formik?.values?.newPassword}
                onChange={formik?.handleChange}
                error={
                  formik?.errors?.newPassword && formik?.touched?.newPassword
                }
                helperText={
                  formik?.errors?.newPassword &&
                  formik?.touched?.newPassword &&
                  formik?.errors?.newPassword
                }
                fullWidth
                variant="outlined"
                size="small"
              ></TextField>
            </Grid>

            {/* Enable Mail */}
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.fieldWrapper}
            >
              <TextField
                name="confirmPassword"
                id="confirmPassword"
                label="Confirm Password"
                value={formik?.values?.confirmPassword}
                defaultValue={formik?.values?.confirmPassword}
                onChange={formik?.handleChange}
                error={
                  formik?.errors?.confirmPassword &&
                  formik?.touched?.confirmPassword
                }
                helperText={
                  formik?.errors?.confirmPassword &&
                  formik?.touched?.confirmPassword &&
                  formik?.errors?.confirmPassword
                }
                fullWidth
                variant="outlined"
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
              <Button variant="contained" onClick={formik.handleSubmit}>
                Update
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <br></br>
      <br></br>
      <br></br>
    </>
  );
};

export default Settings;
